<template>
  <div>
    <a v-if="chatEnabled" class="action" href="#" @click.prevent="loadAndOpenChat">
      <div class="icon"></div>
      <div class="description">
        <span>
          {{ $t('webstars.buttons.chat.title') }}
        </span>
      </div>
    </a>
    <!-- <router-link  class="action"
      :to="{ name: 'purchase.subscription', query: { plan: subscription_plan.id } }">
      <div class="icon"></div>
      <div class="description">
        <span>
          {{ $t('webstars.buttons.chat.not_available') }}
        </span>
        <small>
          {{ $t('webstars.buttons.chat.subtitle') }}
        </small>
      </div>
    </router-link> -->

    <ChatModal 
    v-if="showModal" 
    :model="model" 
    :chat="model.chat" 
    :subscription_plans="chat.subscription_plans"
    @cancel="showModal = false" />
  </div>
</template>
<script>
import resources from "../../resources";
import ChatModal from "../ChatModal"
export default {
  components: { ChatModal },
  props: {
    subscription_plan: {
      type: Object,
      required: false
    },
    model: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      showModal: false,
      loadingModel: false,
      errorModel: false,
      loadingChat: false,
      languageChanged: false,
      chat: null
    };
  },
  methods: {
    loadChatModel(id) {
      this.loadingModel = true;
      this.errorModel = false;

      let data = { id: id };
      return resources.chatModel.apiReadPost(data).then((response) => {
        this.loadingChat = false;
        this.chat = response.data.data;
        if (!this.chat.subscription_plans) {
          this.chat.subscription_plans = [];
        }
      }).catch((error) => {
        this.loadingChat = true;
      });
    },
    openChat() {
      if (this.model.chat.case == 'open_chat') {
        window.location = this.model.chat.url;//.replace("rocketchat:3000", "http://rocketchat.divas.test:3001");
      }
      if (this.model.chat.case == 'modal_login') {
        this.showModal = true;
      }
      if (this.model.chat.case == 'modal_subscription') {
        this.showModal = true;
      }
    },
    loadAndOpenChat() {
      this.loadChatModel(this.model.id).then(() => {
        this.openChat();
      });
    }
  },
  computed: {
    chatEnabled() {
      //si tiene seteado en el .env y es true, el model tiene chat_enabled (chat_setting_enabled = 1 + approved = 1 )
      const chatEnabled = !!(process.env.VUE_APP_CHAT_ENABLED && process.env.VUE_APP_CHAT_ENABLED === 'true');
      return chatEnabled && this.model.chat_enabled;
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.action {
  display: flex;
  width: 300px;
  height: 50px;
  text-align: center;
  background: #dedfe2;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  font-weight: bold;

  .icon {
    width: 80px;
    height: 50px;
    // background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("/img/btn/chat.png");
    background-color: #757576;
  }

  .description {
    width: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;

    small {
      font-size: .6em;
    }
  }
}

.chat-subtitle-username {
  color: var(--pallete_main_color);
}
</style>
